import "./LabelledItem.css";
import React from "react";
import PropTypes from "prop-types";
import HeaderItem from "../../mixins/HeaderItem";
import classNames from "classnames";
import TrackedLink from "../TrackedLink";

class LabelledItem extends React.Component {
    static propTypes = {
        label: PropTypes.object.isRequired,
        icon: PropTypes.string,
        url: PropTypes.string,
        className: PropTypes.string,
        eventLabel: PropTypes.string,
        newTab: PropTypes.bool
    };

    render() {
        const props = {
            className: classNames("label-link", this.props.className, { "has-icon": this.props.icon }),
            href: this.props.url,
            onClick: this.handleClick
        };

        const element = this.props.eventLabel ? TrackedLink : "a";
        if (this.props.eventLabel) {
            props.eventLabel = this.props.eventLabel;
        }

        if (this.props.url && this.props.newTab) {
            props.target = "_blank";
            props.rel = "noopener noreferrer";
        }

        return React.createElement(
            element,
            props,
            [
                (this.props.icon && <i key="icon" className={this.props.icon} />),
                <span key="label" className="header-label">{this.props.label}</span>
            ]);
    }
}

export default HeaderItem(LabelledItem, "labelled-item");
